import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { IGetMonthlyOrderResponse } from "../apis/order/type";

type TSubscriptionRecordsStore = {
  subscriptionRecordList: Array<IGetMonthlyOrderResponse>;
  setSubscriptionRecordList: (
    subscriptionRecordList: Array<IGetMonthlyOrderResponse>
  ) => void;
};

const initState = {
  subscriptionRecordList: [],
};

const useSubscriptionRecordsStore = create<TSubscriptionRecordsStore>()(
  immer((set) => ({
    ...initState,
    setSubscriptionRecordList: (
      subscriptionRecordList: Array<IGetMonthlyOrderResponse>
    ) => {
      const sortedList = subscriptionRecordList?.sort((a, b) => b.id - a.id);

      set((state) => ({ ...state, subscriptionRecordList: sortedList }));
    },
  }))
);

export default useSubscriptionRecordsStore;
